import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Cookies from 'js-cookie';

const TokenHandler = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      // Save token to cookies
      Cookies.set('jwt', token, { expires: 7 }); // 7 days expiry
      
      // Remove token from URL
      window.history.replaceState({}, document.title, window.location.pathname);
      
      // Redirect to sector selection
      navigate('/sector-selection');
    }
  }, [searchParams, navigate]);

  return null;
};

export default TokenHandler;

